import StatBoard from "../../../../utils/game/mechanics/StatBoard";
import FlexColumn from "../../../../common/components/layout/Flexbox/FlexColumn";
import { StatKeyMap } from "../../../../utils/game/mechanics/StatKeyMap";
import Tooltip from "../../../../common/components/wrappers/Tooltip/Tooltip";
import { ReactElement, useMemo } from "react";

import "./ResistancePanel_style.css";

type Props = Readonly<{
    statBoard: StatBoard;
    statKey: string;
    onResistanceTitleClick?: () => void,
}>;

export default function ResistancePanel({
    statBoard,
    statKey,
    onResistanceTitleClick
}: Props): ReactElement {
    const score: number = useMemo(() => {
        return Number.parseInt(statBoard.getValueByStatKey(statKey));
    }, [statBoard, statKey]);

    const scoreTips = statBoard.getTipsByStatKey(statKey, null, null, true);

    const stringifyScore = (val: number): string => {
        if (val <= -2) {
            return "x2";
        } else if (val === -1) {
            return "x1.5";
        } else if (val === 0) {
            return "-";
        } else if (val === 1) {
            return "1/2";
        } else {
            return "X";
        }
    };

    return (
        <FlexColumn className="resistance-panel-container">
            <div className="title" onClick={onResistanceTitleClick}>
                {StatKeyMap.get(statKey)?.replace(" Resistance", "") ?? statKey}
            </div>
            <Tooltip tooltipContent={scoreTips} enabled={scoreTips.length > 0}>
                <div className="score-container">
                    <div className="score">{stringifyScore(score)}</div>
                </div>
            </Tooltip>
        </FlexColumn>
    );
}
